export default __webpack_public_path__ + "static/media/AnimalFeaturesHorns_08.a2327ca3.png";